import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { MultiStepLeadForm } from "../components/lead/MultiStepLeadForm";

export default function Contact() {
	return (
		<div className="pt-24">
			<section className="py-14 md:py-20">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
					<div>
						<p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 dark:text-emerald-400">Contact us</p>
						<h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold text-slate-900 dark:text-white leading-tight">
							Let's talk about your school's growth
						</h1>
						<p className="mt-4 text-lg text-slate-600 dark:text-slate-300 max-w-lg">
							Share a few details and our School Growth Expert will reach out — usually within a couple of hours.
						</p>

						<div className="mt-8 space-y-4">
							<a href="tel:+919876543210" className="flex items-center gap-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 hover:border-emerald-400 transition-colors">
								<span className="grid place-items-center h-11 w-11 rounded-xl bg-emerald-500/10 text-emerald-600"><Phone className="h-5 w-5" /></span>
								<div><p className="text-sm text-slate-500 dark:text-slate-400">Call us</p><p className="font-semibold text-slate-900 dark:text-white">+91 98765 43210</p></div>
							</a>
							<a href="mailto:grow@schoolxpert360.com" className="flex items-center gap-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 hover:border-emerald-400 transition-colors">
								<span className="grid place-items-center h-11 w-11 rounded-xl bg-emerald-500/10 text-emerald-600"><Mail className="h-5 w-5" /></span>
								<div><p className="text-sm text-slate-500 dark:text-slate-400">Email us</p><p className="font-semibold text-slate-900 dark:text-white">grow@schoolxpert360.com</p></div>
							</a>
							<div className="flex items-center gap-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4">
								<span className="grid place-items-center h-11 w-11 rounded-xl bg-emerald-500/10 text-emerald-600"><MapPin className="h-5 w-5" /></span>
								<div><p className="text-sm text-slate-500 dark:text-slate-400">Serving</p><p className="font-semibold text-slate-900 dark:text-white">Schools across India</p></div>
							</div>
						</div>
					</div>

					<div className="rounded-3xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-2xl shadow-slate-900/10 p-6 sm:p-8">
						<div className="mb-5 flex items-center gap-2">
							<MessageCircle className="h-5 w-5 text-emerald-600" />
							<h3 className="font-heading text-xl font-extrabold text-slate-900 dark:text-white">Send us an enquiry</h3>
						</div>
						<MultiStepLeadForm embedded sourcePage="Contact" />
					</div>
				</div>
			</section>
		</div>
	);
}
